/** @module csi/widget/_svg/ShapeAlignHCenter */
define([
	"./_ShapeAlign",
	"./PluginFactory"
], function(_ShapeAlign,PluginFactory) {

	return PluginFactory.declare(_ShapeAlign, {
		/**
		 * @property {String} iconClass - CSS class to be applied.
		 */
		iconClass: "csiActionIcon svgIconAlignHCenter",

		/**
		 * @property {String} pluginName - Plugin name to be used for adding to toolbar.
		 */
		pluginName: "shapeAlignHCenter",

		/**
		 * @property {String} title - Title for the plugin icon.
		 */
		title: "CanvasShapeAlignHCenter",

		/**
		 * @property {String} shapeAlignOption - Shape align option: Top.
		 */
		shapeAlignOption: "hCenter"
	});
});
